<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-file-invoice-dollar"></i>
        파트너 청구서 정보
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">청구</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">파트너 청구서</a>
        </li>
      </ul>
    </div>
    <div>
      <b-row>
        <b-col lg="12" xl="12">
          <b-card id="_share">
            <div class="d-flex flex-wrap align-items-center" v-if="is_show">
              <div class="title mr-auto mb7">
                청구서 안내
              </div>
              <div class="mb7">
                <b-button size="sm" class="float-right" variant="add" @click="share">다운로드</b-button>
              </div>
            </div>
            <hr>
            <b-row>
              <vcl-facebook v-if="loading"></vcl-facebook>
              <b-col sm="12" v-else>
                <!-- <img v-if="model.is_paid" width="200" :src="'img/pay_clear.png'" alt="F1security" :style="pay_clear_css"> -->
                <!-- here code from the template body start -->
                <body style="size: 21cm 29.7cm; background-color:white;">
                  <div id="body" style="margin: 10px; background-color:white;">
                    <center id="header" style="margin: 0px auto; width:80%;">
                      <img style="float: left;" src="F1-uwss.png" alt="partner logo" width="200">
                      <p style="text-decoration:underline; font-weight: bold; margin: 0; font-size: 80px; width: fit-content;">
                        청구서
                      </p>
                    </center>
  
                    <div style="margin-top:50px; text-align:center;">
                      <p style="text-align: right; width:88%; font-weight: bold; margin:0;">
                        정보 보안 솔루션 & 서비스 회사
                      </p>
                      <div style="display:inline-block; width:40%; min-height: 350px; font-weight: bold;">
                        <table style="border-collapse: collapse; width:95%;">
                          <tbody>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro; width:10%;">지급인</td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.username || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro; width:10%;">주소</td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.partner.address || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 60px; background-color: gainsboro; width:10%;">청구서 번호 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.invoice_id || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro; width:10%;">요금</td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{ model.total_price - model.total_partner_price }} {{ model.currency }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro; width:10%;">유효성 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">4주 이내</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro; width:10%;">발급 날짜 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;">{{  model.created_at | datetime }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
  
                      <div style="display:inline-block; width:40%; min-height:350px; font-weight: bold;">
                        <table style="border-collapse: collapse; width:95%; margin: 0 auto;">
                          <tbody>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">회사 이름 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:10%;"> {{ model.bill_custom.company || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">회사 주소 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">
                                {{ model.bill_custom.company_address || '-' }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 60px; background-color: gainsboro;">
                                사업 등록 번호
                              </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;">{{ model.bill_custom.business_number  || '-' }}</td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;"> 발행인 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer  || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;">이메일 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.issuer_email  || '-' }} </td>
                            </tr>
                            <tr>
                              <td style="border: 2px solid black; padding:2px; height: 45px; background-color: gainsboro;"> 전화 번호 </td>
                              <td style="border: 2px solid black; padding:2px; height: 45px; width:30%;"> {{ model.bill_custom.contact  || '-' }} </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <br>
  
                      <div style="display:inline-block; width:80%; text-align:left;">
                        <h2 style="padding-left: 15px;" v-if="model.start_at || model.end_at">
                          청구 기간:  {{ model.start_at | date }} -  {{ model.end_at | date }}
                        </h2>
                        <h2 style="padding-left: 15px;" v-else>
                          청구 기간:  -
                        </h2>
                        <p style="padding-left: 50px;">
                          F1 Security, Inc 와의 파트너십 프로그램에 참여해주셔서 감사해요.
                          <br>
                          저희는 UWSS 사용자를 위해 전자 청구서를 만들었어요.
                          <br>
                          추가 정보는 파트너 콘솔 사이트에 접속하여 청구 페이지를 확인해주세요.
                        </p>
                      </div>
                    </div>
                    <p style="text-align: right; width:90%; font-weight: bold; margin:0;">
                      ( {{ model.currency || '-' }} )
                    </p>
                    <div style="margin: 0 auto; text-align:center; font-weight: bold; width: 80%;">
                      <table style="border: 2px solid black; border-collapse: collapse; border-spacing: 0;">
                        <tr style="background-color: gainsboro; width:100%;">
                          <th style="padding: 5px; border: 2px solid black; width: 50%;">사용자</th>
                          <th style="padding: 5px; border: 2px solid black; width: 18%;">서비스 타입</th>
                          <th style="padding: 5px; border: 2px solid black; width: 12%;">사용 수량</th>
                          <th style="padding: 5px; border: 2px solid black; width: 18%;">사용량</th>
                          <th style="padding: 5px; border: 2px solid black; width: 5%;">비고</th>
                        </tr>
                        <tr v-for="(x, id) in model.group_list_cache" v-bind:key="id">
                          <td style="padding: 5px; border-top: black solid 2px; width: 55%;"> {{ x.groupname }}</td>
                          <td style="border: black solid 2px; width: 18%;"> {{ x.service_name }}</td>
                          <td style="border: black solid 2px; width: 12%;"> {{ x.total_usage }}</td>
                          <!-- 에프원 제공 가격에서 파트너의 이익 뺀 가격임 -->
                          <td style="border: black solid 2px; width: 18%;"> {{ x.total_price - x.partner_price }}</td>
                          <td style="border: black solid 2px; width: 5%;">
                            {{ x.total_price == 0 ? '✓' : '' }}
                          </td>
                        </tr>
                        <tr>
                          <td style="background-color: gainsboro; padding: 5px; border: black solid 2px; width: 78%;" colspan="3">Charges (Total)</td>
                          <td style="padding: 5px; border: black solid 2px; width: 18%;"> {{ model.total_price - model.total_partner_price }}</td>
                          <td style="padding: 5px; border: black solid 2px; width: 5%;">  VAT Included </td>
                        </tr>
                      </table>
                      <span style="float: left; padding-top:5px;">(*1) 일일이용료 계산시 1개월은 30일</span>
                      <br>
                      <div style="margin-top:50px;" v-if="model.bill_custom">
                        <span style="float:left">결제수단 : (주)에프원시큐리티 지정 은행계좌로 입금해주세요.</span>
                        <table style="border: 2px solid black; border-collapse: collapse; border-spacing: 0; width: 100%;">
                          <tr>
                            <th style="padding: 5px; border: 2px solid black; background-color: gainsboro; width: 15%;">은행 이름</th>
                            <th style="padding: 5px; border: 2px solid black; width: 45%;"> {{ model.bill_custom.bank_name || '-' }} </th>
                            <th style="padding: 5px; border: 2px solid black; background-color: gainsboro; width: 20%;">  스위프트 코드 </th>
                            <th style="padding: 5px; border: 2px solid black; width: 20%;"> {{ model.bill_custom.swift_code || '-' }} </th>
                          </tr>
                          <tr>
                            <td style="border: black solid 2px; background-color: gainsboro; width: 15%;"> 계좌 번호 </td>
                            <td style="border: black solid 2px; width: 45%;"> {{ model.bill_custom.bank_number }}</td>
                            <td style="border: black solid 2px; background-color: gainsboro; width: 20%;"> 계좌 소유자 </td>
                            <td style="border: black solid 2px; width: 20%;"> {{ model.bill_custom.account_holder || '-' }} </td>
                          </tr>
                          <tr>
                            <td style="padding: 5px; border-top: black solid 2px; background-color: gainsboro; width: 15%;"> 은행 지점 </td>
                            <td style="border: black solid 2px;" colspan="3"> {{ model.bill_custom.bank_branch || '-' }} </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div id="footer">
                    <img style="float:right; margin-top:50px;" :src="model.logo" alt="partner logo" width="200" v-if="model.logo">
                    <img style="float:right; margin-top:50px; margin-right:10%;" src="img/F1security.png" alt="partner logo" width="200" v-else>
                  </div>
                </body>
                <!-- here code from the template body end  -->
              </b-col>
            </b-row>
          </b-card>
          <b-card id="_share">
            <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
            <b-row v-if="!loading">
              <b-col md="12">
                <label class="col-form-label" for=""><h4>부분 결제 내역</h4></label>
              </b-col>
              <b-col md="12">
                <!-- TODO : 테이블로 예쁘게 해야 함 -->
                <ul class="list-group">
                  <li class="list-group-item" v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300 }">
                    <small v-if="item && item.payer">
                      <!-- paypal -->
                      [결제 날짜:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                      [회사:{{item.payer.email_address}}]
                      [작업:{{item.purchase_units[0].description}}]
                      [결제 방법:{{item.pg}}]
                      [가격:{{item.purchase_units[0].amount.value}}]
                      [원화:{{item.purchase_units[0].amount.currency_code}}]
                      [국가:{{item.payer.address.country_code}}]
                    </small>
                    <small v-else>
                      <!-- boot_pay or credit -->
                      [결제 날짜:{{item.purchased_at | datetime}}]
                      [회사:{{item.pg_name}}]
                      [작업:{{item.action}}]
                      [결제 방법:{{item.pg}}]
                      [가격:{{item.price}}]
                      [원화:{{'KRW'}}]
                      [국가:{{'KR'}}]
                    </small>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <hr v-if="is_show">
            <b-button v-if="is_show" :disabled="model.is_paid" class="float-left m-1" size="sm" variant="outline-primary" @click="is_pay = true; model.pay_price = model.total_price"> 수동 결제 </b-button>
            <b-button v-if="is_show" size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
          </b-card>
        </b-col>
      </b-row>
  
      <router-view></router-view>
      <!-- modal area -->
      <b-modal title="수동 결제" header-bg-variant="warning" v-model="is_pay" @ok="pay" ok-variant="outline-warning" ok-title="결제" cancel-title="취소" cancel-variant="outline-dark">
        <!-- <b-checkbox class="ml-3 mt-1" v-model="use_system_credit">Use System Credit (default using partner's credit)</b-checkbox>
        <hr> -->
        <!-- <span> -->
          <!-- Payment can be made with partner's credit or system's credit -->
          <!-- 파트너의 신용으로 결제
        </span> -->
        <b-form-input md=12 type="text" id="ph_name" v-model="model.pay_price" ></b-form-input>
      </b-modal>
    </div>
    </div>
  </template>
  
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>